import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'


class MeetingSchedule extends React.Component {
  constructor(props) {
    super(props)

    const {meeting_time, lang_one, lang_two} = this.props

    this.state = {
      meeting_time: meeting_time,
      lang_one: lang_one,
      lang_two: lang_two
    }
  }

  render() {
      if(this.state.lang_one !== null && this.state.lang_two !== null) {
        return(
          <div>
              <div style={{display: 'flex', marginBottom: 5, flexDirection: 'row'}}>
                  <div className="meetingLangOneSymbol"><p >{this.state.lang_one.locale}</p></div>
                  <p className="sectionText red" style={{fontWeight: 500, marginTop: 2}}>{moment(this.state.meeting_time).format("h:mm")} {this.state.lang_one.native} Only</p>
              </div>
              <div style={{display: 'flex', flexDirection: 'row'}}>
                  <div className="meetingLangTwoSymbol"><p>{this.state.lang_two.locale}</p></div>
                    <p className="sectionText mediumBlue" style={{fontWeight: 500, marginTop: 2}}>{moment(this.state.meeting_time).add(30, 'minutes').format("h:mm")} {this.state.lang_two.native} Only</p>
              </div>
          </div>
        )
    }
  return <h3>Invalid Times</h3>;
  }
}

export default MeetingSchedule;
